var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state-container"},[_c('div',{staticClass:"icon-section"},[_c('mf-icon',{attrs:{"color":"cinza-l10"}},[_vm._v(" monitoring ")])],1),_c('span',[_vm._v("Sem dados para exibição")])])}
var staticRenderFns = []

export { render, staticRenderFns }